// wcwb/frontend/src/components/CreateEventModal.js
import { useState } from 'react';
import { S } from './styles';

const AI_THEMES = [
  { emoji:'🌸', title:'Spring Japanese Kappo', desc:'Omakase-style, cherry blossom motifs, sake pairings' },
  { emoji:'🇲🇦', title:'Moroccan Riad Night', desc:'Tagines, preserved lemons, rose water desserts' },
  { emoji:'🌊', title:'Coastal Peruvian', desc:'Ceviche, tiradito, pisco sours' },
  { emoji:'🍄', title:'Forest & Forage', desc:'Wild mushrooms, truffle, autumn earth tones' },
  { emoji:'🌶️', title:'Oaxacan Fiesta', desc:'Mole negro, mezcal cocktails, vibrant colours' },
  { emoji:'🧆', title:'Levantine Mezze Feast', desc:'Small plates, hummus, sumac lamb, fresh herbs' },
];

const EMOJIS = ['🍽️','🫒','🍂','🌮','🍜','🎉','🥂','🫕','🍣','🥗','🌸','🧆'];

const TIMEZONES = [
  { group:'North America', zones:[
    { value:'America/St_Johns',    label:'Newfoundland (NST/NDT)' },
    { value:'America/Halifax',     label:'Atlantic (AST/ADT)' },
    { value:'America/Toronto',     label:'Eastern (EST/EDT)' },
    { value:'America/Chicago',     label:'Central (CST/CDT)' },
    { value:'America/Denver',      label:'Mountain (MST/MDT)' },
    { value:'America/Vancouver',   label:'Pacific (PST/PDT)' },
    { value:'America/Anchorage',   label:'Alaska (AKST/AKDT)' },
    { value:'Pacific/Honolulu',    label:'Hawaii (HST)' },
  ]},
  { group:'Europe', zones:[
    { value:'Europe/London',       label:'London (GMT/BST)' },
    { value:'Europe/Paris',        label:'Paris / Berlin (CET/CEST)' },
    { value:'Europe/Helsinki',     label:'Helsinki (EET/EEST)' },
    { value:'Europe/Moscow',       label:'Moscow (MSK)' },
  ]},
  { group:'Asia / Pacific', zones:[
    { value:'Asia/Dubai',          label:'Dubai (GST)' },
    { value:'Asia/Kolkata',        label:'India (IST)' },
    { value:'Asia/Singapore',      label:'Singapore (SGT)' },
    { value:'Asia/Tokyo',          label:'Tokyo (JST)' },
    { value:'Australia/Sydney',    label:'Sydney (AEST/AEDT)' },
    { value:'Pacific/Auckland',    label:'Auckland (NZST/NZDT)' },
  ]},
  { group:'Other', zones:[
    { value:'UTC',                 label:'UTC' },
    { value:'America/Sao_Paulo',   label:'São Paulo (BRT)' },
    { value:'Africa/Johannesburg', label:'Johannesburg (SAST)' },
  ]},
];

const inputStyle = {
  width:'100%', padding:'10px 13px', border:'1px solid #E5D9C8',
  borderRadius:10, fontFamily:'Jost,sans-serif', fontSize:14,
  color:'#2C1A0E', outline:'none', marginBottom:16, background:'white',
};

export default function CreateEventModal({ onClose, onCreate }) {
  const [form, setForm] = useState({
    title:'', date:'', time:'7:00 PM', address:'', theme:'',
    emoji:'🍽️', banner_bg:'#3E2723', guest_emails:'', timezone:'America/Denver',
  });
  const [showThemes, setShowThemes] = useState(false);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');

  async function handleCreate() {
    setLoading(true); setError('');
    try {
      const guest_emails = form.guest_emails.split(',').map(e => e.trim()).filter(Boolean);
      await onCreate({ ...form, guest_emails });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(44,26,14,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:16 }} onClick={onClose}>
      <div style={{ background:'white', borderRadius:24, width:'100%', maxWidth:540, maxHeight:'92vh', overflowY:'auto', padding:32 }} onClick={e => e.stopPropagation()}>

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
          <div>
            <h3 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:24 }}>Host a dinner party</h3>
            <p style={{ fontSize:13, color:'#7A6555', marginTop:4 }}>Set the scene and invite your people</p>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer', color:'#7A6555' }}>×</button>
        </div>

        {error && <div style={{ background:'#FFEBEE', color:'#B71C1C', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:16 }}>{error}</div>}

        <label style={S.label}>Party emoji</label>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:16 }}>
          {EMOJIS.map(e => (
            <button key={e} onClick={() => setForm(f => ({ ...f, emoji:e }))}
              style={{ fontSize:22, background:form.emoji===e?'#FAEEE8':'transparent', border:form.emoji===e?'2px solid #C4612A':'2px solid transparent', borderRadius:8, padding:'4px 8px', cursor:'pointer' }}>
              {e}
            </button>
          ))}
        </div>

        <label style={S.label}>Event name</label>
        <input style={inputStyle} placeholder="e.g. Midsummer Mediterranean Night"
          value={form.title} onChange={e => setForm(f => ({ ...f, title:e.target.value }))} />

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          <div>
            <label style={S.label}>Date</label>
            <input type="date" style={inputStyle} value={form.date}
              onChange={e => setForm(f => ({ ...f, date:e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Time</label>
            <input style={inputStyle} value={form.time}
              onChange={e => setForm(f => ({ ...f, time:e.target.value }))} />
          </div>
        </div>

        <label style={S.label}>Timezone</label>
        <select style={inputStyle} value={form.timezone} onChange={e => setForm(f => ({ ...f, timezone:e.target.value }))}>
          {TIMEZONES.map(group => (
            <optgroup key={group.group} label={group.group}>
              {group.zones.map(tz => (
                <option key={tz.value} value={tz.value}>{tz.label}</option>
              ))}
            </optgroup>
          ))}
        </select>

        <label style={S.label}>Address</label>
        <input style={inputStyle} placeholder="Your address"
          value={form.address} onChange={e => setForm(f => ({ ...f, address:e.target.value }))} />

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
          <label style={{ ...S.label, marginBottom:0 }}>Theme & vibe</label>
          <button onClick={() => setShowThemes(!showThemes)}
            style={{ background:'none', border:'none', cursor:'pointer', color:'#C4612A', fontSize:12, fontWeight:500 }}>
            ✨ AI suggestions
          </button>
        </div>
        {showThemes && (
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:12 }}>
            {AI_THEMES.map(t => (
              <div key={t.emoji}
                onClick={() => { setForm(f => ({ ...f, theme:t.desc, emoji:t.emoji, title:f.title||t.title })); setShowThemes(false); }}
                style={{ border:'1px solid #E5D9C8', borderRadius:12, padding:'12px 14px', cursor:'pointer', transition:'all .15s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#C4612A'; e.currentTarget.style.background='#FAEEE8'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='#E5D9C8'; e.currentTarget.style.background='transparent'; }}>
                <div style={{ fontSize:13, fontWeight:500 }}>{t.emoji} {t.title}</div>
                <div style={{ fontSize:11, color:'#7A6555', marginTop:4 }}>{t.desc}</div>
              </div>
            ))}
          </div>
        )}
        <textarea style={{ ...inputStyle, resize:'vertical', minHeight:72 }}
          placeholder="Describe the cuisine theme, dress code, atmosphere…"
          value={form.theme} onChange={e => setForm(f => ({ ...f, theme:e.target.value }))} />

        <label style={S.label}>Invite guests (emails, comma-separated)</label>
        <input style={inputStyle} placeholder="friend@email.com, another@email.com"
          value={form.guest_emails} onChange={e => setForm(f => ({ ...f, guest_emails:e.target.value }))} />

        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          <button style={S.btnGhost} onClick={onClose}>Cancel</button>
          <button
            style={{ ...S.btnPrimary, opacity:(!form.title||!form.date||loading)?0.5:1 }}
            disabled={!form.title||!form.date||loading}
            onClick={handleCreate}>
            {loading ? 'Creating…' : 'Create event'}
          </button>
        </div>
      </div>
    </div>
  );
}
